import { all, call, put, select, takeLatest } from 'redux-saga/effects';
import { AuthApi } from 'vrlcm-gui-api';
import {
  EnvironmentState,
  GroupMetadata,
  User,
  VcfInfraData
} from 'vrlcm-gui-types';
import { isVcfPoweredProduct } from 'vrlcm-gui-utils';
import {
  initializeStepNetworkFailed,
  initializeStepNetworkSuccess
} from '../../../actions/workflows/steps/Network';
import InfrastructureStepAPI from '../../../api/workflows/steps/Infrastructure';
import * as Constants from '../../../constants/action-constants';
import { StoreState } from '../../../types';

function* initializeStepNetwork() {
  try {
    const groups: GroupMetadata[] = yield call(
      InfrastructureStepAPI.getInfrastructureMetadata
    );
    const networkProperties = groups.find(g => g.name === 'environmentNetwork');
    const user: User = yield call(AuthApi.whoAmI);
    const { environmentRequestDTO }: EnvironmentState = yield select(
      (s: StoreState) => s.environmentWorkflow.state
    );
    const { products } = environmentRequestDTO;
    const fetchVcfProperties = isVcfPoweredProduct(environmentRequestDTO, user);
    if (fetchVcfProperties) {
      let vcfInfraData: VcfInfraData | undefined;
      try {
        vcfInfraData = yield call(
          InfrastructureStepAPI.getPropertiesFromVcf,
          products[0].id
        );
      } catch {
        /** */
      }
      yield put(
        initializeStepNetworkSuccess(
          networkProperties ? networkProperties.properties : undefined,
          vcfInfraData
        )
      );
    } else {
      yield put(
        initializeStepNetworkSuccess(
          networkProperties ? networkProperties.properties : undefined
        )
      );
    }
  } catch (e) {
    yield put(initializeStepNetworkFailed());
  }
}

function* watchForNetwork() {
  yield takeLatest(Constants.INITIALIZE_STEP_NETWORK, initializeStepNetwork);
}

export default function* networkSaga() {
  yield all([watchForNetwork()]);
}
